import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72d75619"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fm-read-container" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "fm-title",
      textContent: _toDisplayString(_ctx.audioDetail.title1)
    }, null, 8, _hoisted_2),
    _createElementVNode("span", {
      innerHTML: _ctx.audioDetail.introduction
    }, null, 8, _hoisted_3)
  ]))
}